<template>
  <vx-card no-shadow>

    <!-- Info -->
    <vs-input class="w-full mb-base" label-placeholder="Vezetéknév" v-model="user.firstName"></vs-input>
    <vs-input class="w-full mb-base" label-placeholder="Keresztnév" v-model="user.lastName"></vs-input>
    <vs-input class="w-full" label-placeholder="Email" v-model="user.email" disabled></vs-input>

    <!-- Save & Reset Button -->
    <div class="flex flex-wrap items-center">
      <vs-button class="mt-2" @click="saveUser()">Mentés</vs-button>
    </div>
  </vx-card>
</template>

<script>
export default {
  data() {
    return {
		username: "johny_01",
		name: this.$store.state.AppActiveUser.displayName,
		email: "john@admin.com",
		company: "SnowMash Technologies Pvt Ltd",
		user: {}
    }
  },
  computed: {
    activeUserInfo() {
      return this.$store.state.AppActiveUser
    },
  },
  methods: {
	getUser() {
		this.$http.get('/api/users/show/' + this.activeUserInfo.id)
			.then((response) => {
				this.user = response.data.data
			})
			.catch((error) => { console.log(error) })
	},
	saveUser() {
		this.$http.post('/api/users/update/' + this.user.id, this.user)
			.then(() => {
				this.$vs.notify({
					title: 'Siker',
					text: 'Sikeres mentés',
					iconPack: 'feather',
					icon: 'icon-alert-circle',
					color: 'success',
					position: 'bottom-center'
				})
			})
			.catch((error) => {
				let errors = error.response.data
				let errorMessage = ''
				for (let key in errors) {
					errorMessage += errors[key][0] + '<br>'

				}
				this.showError(errorMessage)
			})
	},
	showError(errorMessage) {
			this.$vs.loading.close()
			this.$vs.notify({
				time: 8000,
				title: 'Hiba',
				text: errorMessage,
				iconPack: 'feather',
				icon: 'icon-alert-circle',
				color: 'danger',
				position: 'bottom-center'
			})
		}
  },
  mounted() {
		this.getUser();
  }
}
</script>
